/**
 * Task priority as the design's tones.
 *
 * The screen used to carry its own Tailwind colour map (bg-red-100 for urgent,
 * bg-orange-100 for high and so on), which meant "late" was a different red here
 * than on every other CRM list. `StatusPill` already owns those five tones, so a
 * priority only has to say which of them it is.
 *
 * Normal deliberately maps to `mut` rather than `info`: it is the default every
 * task is created with, and a coloured pill on nine rows out of ten tells you
 * nothing. Only a priority somebody actually chose gets a colour.
 */
import type { StatusTone } from "../../ui";
import type { TaskPriority } from "../../../lib/projects";

/** Low to high, the order the filter menu lists them in. */
export const PRIORITIES: TaskPriority[] = ["low", "normal", "high", "urgent"];

const PRIORITY_TONE: Record<TaskPriority, StatusTone> = {
  low: "mut",
  normal: "mut",
  high: "wt",
  urgent: "lt",
};

export function priorityTone(p: TaskPriority): StatusTone {
  return PRIORITY_TONE[p];
}

/** Whether the priority is worth a pill at all - see the note above. */
export function priorityIsNotable(p: TaskPriority): boolean {
  return p === "high" || p === "urgent";
}
